import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};

export const AttachmentIcon = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '13';
			case SIZE.STANDARD:
				return '20';
			default:
				return '20';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '13';
			case SIZE.STANDARD:
				return '20';
			default:
				return '20';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg
				width={getWidth(size)}
				height={getHeight(size)}
				fill={color}
				viewBox="0 0 20 20"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Icon-Archieve" transform="translate(-410.000000, -37.000000)" fill={color}>
						<path
							d="M425.6572,38.4419 C423.6082,36.3939 420.4862,36.5419 418.2322,38.7959 L412.2212,44.8059 C409.4002,47.6279 409.2482,51.7319 411.8682,54.3519 C414.4882,56.9719 418.5932,56.8199 421.4142,53.9989 L426.3642,49.0479 L424.9502,47.6339 L420.0002,52.5839 C417.9512,54.6329 415.1262,54.7809 413.2822,52.9379 C411.4382,51.0939 411.5872,48.2689 413.6362,46.2199 L419.6462,40.2099 C420.8792,38.9769 422.7772,38.3909 424.2432,39.8559 C425.3662,40.9789 424.9102,42.7029 423.5242,44.0879 L417.5732,50.0979 C416.8442,50.8259 416.3222,51.0049 415.7682,50.4519 C415.2902,49.9729 415.4532,49.4339 416.1802,48.7059 L421.7792,43.0489 L420.3642,41.6349 L414.7662,47.2919 C413.2312,48.8269 413.0602,50.5719 414.3542,51.8659 C415.6472,53.1599 417.3932,53.0469 418.9282,51.5119 L424.9382,45.5019 C427.5792,42.8609 427.4472,40.2319 425.6572,38.4419"
							id="ico-attachment"
						></path>
					</g>
				</g>
			</svg>
		</StyledSpan>
	);
};

AttachmentIcon.SIZE = SIZE;
AttachmentIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

AttachmentIcon.defaultProps = {
	color: '#ADAFB8', //757575
};

export const StyledSpan = Styled.span`
	display: inline;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
